export default "/_next/static/images/954cd2e60600db3a1b7393dc205c78c0.jpg";